import {qspost, qspostfile} from '@/plugins/axios'

/*
 * 首页统计
 * @constructor jack
 * */
export const homeTongJi = (searchTime = 1, startTime, endTime, xiangMuId, xiaoQuId) => qspost('/Index/Tongji/homeTongJi', {
  searchTime,
  startTime,
  endTime,
  xiangMuId,
  xiaoQuId
})

/*
 * 综合改造的统计
 * @constructor jack
 * */
export const zongHeGaiZaoTongJi = (searchTime = 1, startTime, endTime, xiangMuId, xiaoQuId) => qspost('/Index/Tongji/zongHeGaiZaoTongJi', {
  searchTime,
  startTime,
  endTime,
  xiangMuId,
  xiaoQuId
})

/*
 * 民意调查统计 第一部分 上面的数据统计
 * @constructor jack
 * */
export const minYiDiaoChaOne = (xiangMuId, xiaoQuId,adminId) => qspost('/Index/Xinxuqiu/minYiDiaoChaOne', {
  xiangMuId,
  xiaoQuId,
  adminId
})

/*
 * 民意调查统计 第二部分 下面的楼宇分布图
 * @constructor jack
 * */
export const minYiDiaoChaTwo = (xiangMuId, xiaoQuId,adminId) => qspost('/Index/Xinxuqiu/minYiDiaoChaTwo', {
  xiangMuId,
  xiaoQuId,adminId
})

/*
 * 物业管理统计 （总负责人、社区、普通员工）
 * @constructor jack
 * */
export const wuYeGuanLi = (xiangMuId, xiaoQuId) => qspost('/Index/Tongji/wuYeGuanLi', {
  xiangMuId,
  xiaoQuId
})

/*
 * 物业统计统计 第一部分 上方数据（总负责人、社区）
 * @constructor jack
 * */
export const wuYeTongJiOne = (xiangMuId, xiaoQuId, nian) => qspost('/Index/Tongji/wuYeTongJiOne', {
  xiangMuId,
  xiaoQuId,
  nian
})

/*
 * 物业统计统计 第二部分 下方数据 （总负责人、社区）
 * @constructor jack
 * */
export const wuYeTongJiTwo = (xiangMuId, xiaoQuId, nian) => qspost('/Index/Tongji/wuYeTongJiTwo', {
  xiangMuId,
  xiaoQuId,
  nian
})

/*
 * 获得自己旗下的修改人列表
 * @constructor jack
 * */
export const getXiuGaiRen = () => qspost('/Index/Weblog/getXiuGaiRen', {})

/*
 * 日志列表
 * @constructor jack
 * */
export const webLogList = (startTime, endTime, lanMuId, xiuGaiRen, xiangMuId, xiaoQuId, louId, menId, huId, page, pageSize) => qspost('/Index/Weblog/webLogList', {
  startTime, endTime, lanMuId, xiuGaiRen, xiangMuId, xiaoQuId, louId, menId, huId,page, pageSize
})

/*
 * 日志列表导出
 * @constructor jack
 * */
export const webLogExport = (startTime, endTime, lanMuId, xiuGaiRen, xiangMuId, xiaoQuId, louId, menId, huId, page, pageSize) => qspostfile('/Index/Export/exportWebLogList', {
  startTime, endTime, lanMuId, xiuGaiRen, xiangMuId, xiaoQuId, louId, menId, huId
})
